
export const GET_MODALITY_DEVICE = 'GET_MODALITY_DEVICE'
export const GET_MODALITY_DEVICE_REQUEST = 'GET_MODALITY_DEVICE_REQUEST'
export const GET_MODALITY_DEVICE_SUCCESS = 'GET_MODALITY_DEVICE_SUCCESS'
export const GET_MODALITY_DEVICE_FAILURE = 'GET_MODALITY_DEVICE_FAILURE'


export const getModalityDeviceRequest = (payload) => ({ type: GET_MODALITY_DEVICE_REQUEST, payload })
export const getModalityDeviceSuccess = (data) => ({ type: GET_MODALITY_DEVICE_SUCCESS, data })
export const getModalityDeviceFailure = (error) => ({ type: GET_MODALITY_DEVICE_FAILURE, payload: error })

export const PUT_MODALITY_DEVICE = 'PUT_MODALITY_DEVICE'
export const PUT_MODALITY_DEVICE_REQUEST = 'PUT_MODALITY_DEVICE_REQUEST'
export const PUT_MODALITY_DEVICE_SUCCESS = 'PUT_MODALITY_DEVICE_SUCCESS'
export const PUT_MODALITY_DEVICE_FAILURE = 'PUT_MODALITY_DEVICE_FAILURE'


export const putModalityDeviceRequest = (payload) => ({ type: PUT_MODALITY_DEVICE_REQUEST, payload })
export const putModalityDeviceSuccess = (data) => ({ type: PUT_MODALITY_DEVICE_SUCCESS, data })
export const putModalityDeviceFailure = (error) => ({ type: PUT_MODALITY_DEVICE_FAILURE, payload: error })


export const POST_MODALITY_DEVICE = 'POST_MODALITY_DEVICE'
export const POST_MODALITY_DEVICE_REQUEST = 'POST_MODALITY_DEVICE_REQUEST'
export const POST_MODALITY_DEVICE_SUCCESS = 'POST_MODALITY_DEVICE_SUCCESS'
export const POST_MODALITY_DEVICE_FAILURE = 'POST_MODALITY_DEVICE_FAILURE'


export const postModalityDeviceRequest = (payload) => ({ type: POST_MODALITY_DEVICE_REQUEST, payload })
export const postModalityDeviceSuccess = (data) => ({ type: POST_MODALITY_DEVICE_SUCCESS, data })
export const postModalityDeviceFailure = (error) => ({ type: POST_MODALITY_DEVICE_FAILURE, payload: error })


export const GET_MODALITY_SEARCH_DEVICE = 'GET_MODALITY_SEARCH_DEVICE'
export const GET_MODALITY_SEARCH_DEVICE_REQUEST = 'GET_MODALITY_SEARCH_DEVICE_REQUEST'
export const GET_MODALITY_SEARCH_DEVICE_SUCCESS = 'GET_MODALITY_SEARCH_DEVICE_SUCCESS'
export const GET_MODALITY_SEARCH_DEVICE_FAILURE = 'GET_MODALITY_SEARCH_DEVICE_FAILURE'


export const getModalitySearchDeviceRequest = (payload) => ({ type: GET_MODALITY_SEARCH_DEVICE_REQUEST, payload })
export const getModalitySearchDeviceSuccess = (data) => ({ type: GET_MODALITY_SEARCH_DEVICE_SUCCESS, data })
export const getModalitySearchDeviceFailure = (error) => ({ type: GET_MODALITY_SEARCH_DEVICE_FAILURE, payload: error })


export const POST_SERVICE_DEVICE = 'POST_SERVICE_DEVICE'
export const POST_SERVICE_DEVICE_REQUEST = 'POST_SERVICE_DEVICE_REQUEST'
export const POST_SERVICE_DEVICE_SUCCESS = 'POST_SERVICE_DEVICE_SUCCESS'
export const POST_SERVICE_DEVICE_FAILURE = 'POST_SERVICE_DEVICE_FAILURE'


export const postServiceDeviceRequest = (payload) => ({ type: POST_SERVICE_DEVICE_REQUEST, payload })
export const postServiceDeviceSuccess = (payload) => ({ type: POST_SERVICE_DEVICE_SUCCESS, payload })
export const postServiceDeviceFailure = (error) => ({ type: POST_SERVICE_DEVICE_FAILURE, payload: error })


export const DELETE_SERVICE_DEVICE_REQUEST = 'DELETE_SERVICE_DEVICE_REQUEST'
export const deleteServiceDeviceRequest = (payload) => ({ type: DELETE_SERVICE_DEVICE_REQUEST, payload })


export const PUT_SERVICE_DEVICE = 'PUT_SERVICE_DEVICE'
export const PUT_SERVICE_DEVICE_REQUEST = 'PUT_SERVICE_DEVICE_REQUEST'
export const PUT_SERVICE_DEVICE_SUCCESS = 'PUT_SERVICE_DEVICE_SUCCESS'
export const PUT_SERVICE_DEVICE_FAILURE = 'PUT_SERVICE_DEVICE_FAILURE'


export const putServiceDeviceRequest = (payload) => ({ type: PUT_SERVICE_DEVICE_REQUEST, payload })
export const putServiceDeviceSuccess = (payload) => ({ type: PUT_SERVICE_DEVICE_SUCCESS, payload })
export const putServiceDeviceFailure = (error) => ({ type: PUT_SERVICE_DEVICE_FAILURE, payload: error })


export const GET_SERVICE_SEARCH_DEVICE = 'GET_SERVICE_SEARCH_DEVICE'
export const GET_SERVICE_SEARCH_DEVICE_REQUEST = 'GET_SERVICE_SEARCH_DEVICE_REQUEST'
export const GET_SERVICE_SEARCH_DEVICE_SUCCESS = 'GET_SERVICE_SEARCH_DEVICE_SUCCESS'
export const GET_SERVICE_SEARCH_DEVICE_FAILURE = 'GET_SERVICE_SEARCH_DEVICE_FAILURE'


export const getServiceSearchDeviceRequest = (payload) => ({ type: GET_SERVICE_SEARCH_DEVICE_REQUEST, payload })
export const getServiceSearchDeviceSuccess = (payload) => ({ type: GET_SERVICE_SEARCH_DEVICE_SUCCESS, payload })
export const getServiceSearchDeviceFailure = (error) => ({ type: GET_SERVICE_SEARCH_DEVICE_FAILURE, payload: error })


export const GET_SCHEDULE_DEVICES = 'GET_SCHEDULE_DEVICES'
export const GET_SCHEDULE_DEVICES_REQUEST = 'GET_SCHEDULE_DEVICES_REQUEST'
export const GET_SCHEDULE_DEVICES_SUCCESS = 'GET_SCHEDULE_DEVICES_SUCCESS'
export const GET_SCHEDULE_DEVICES_FAILURE = 'GET_SCHEDULE_DEVICES_FAILURE'


export const getScheduleDevicesRequest = (payload) => ({ type: GET_SCHEDULE_DEVICES_REQUEST, payload })
export const getScheduleDevicesSuccess = (payload) => ({ type: GET_SCHEDULE_DEVICES_SUCCESS, payload })
export const getScheduleDevicesFailure = (error) => ({ type: GET_SCHEDULE_DEVICES_FAILURE, payload: error })


export const GET_USER_PROFILE = 'GET_USER_PROFILE'
export const GET_USER_PROFILE_REQUEST = 'GET_USER_PROFILE_REQUEST'
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS'
export const GET_USER_PROFILE_FAILURE = 'GET_USER_PROFILE_FAILURE'


export const getUserProfileRequest = (payload) => ({ type: GET_USER_PROFILE_REQUEST, payload })
export const getUserProfileSuccess = (payload) => ({ type: GET_USER_PROFILE_SUCCESS, payload })
export const getUserProfileFailure = (error) => ({ type: GET_USER_PROFILE_FAILURE, payload: error })


export const PUT_USER_PROFILE = 'PUT_USER_PROFILE'
export const PUT_USER_PROFILE_REQUEST = 'PUT_USER_PROFILE_REQUEST'
export const PUT_USER_PROFILE_SUCCESS = 'PUT_USER_PROFILE_SUCCESS'
export const PUT_USER_PROFILE_FAILURE = 'PUT_USER_PROFILE_FAILURE'


export const putUserProfileRequest = (payload) => ({ type: PUT_USER_PROFILE_REQUEST, payload })
export const putUserProfileSuccess = (payload) => ({ type: PUT_USER_PROFILE_SUCCESS, payload })
export const putUserProfileFailure = (error) => ({ type: PUT_USER_PROFILE_FAILURE, payload: error })


export const GET_SELECT_FACILITY_SUCCESS = 'GET_SELECT_FACILITY_SUCCESS'


export const getSelectFacilityId = (payload) => ({ type: GET_SELECT_FACILITY_SUCCESS, payload })


export const POST_RESET_PASSWORD_REQUEST = 'POST_RESET_PASSWORD_REQUEST'
export const POST_RESET_PASSWORD_SUCCESS = 'POST_RESET_PASSWORD_SUCCESS'
export const POST_RESET_PASSWORD_FAILURE = 'POST_RESET_PASSWORD_FAILURE'

export const postResetPasswordRequest = (requestBody) => ({ type: POST_RESET_PASSWORD_REQUEST, payload: { requestBody } })
export const postResetPasswordSuccess = (data) => ({ type: POST_RESET_PASSWORD_SUCCESS, data })
export const postResetPasswordFailure = (error) => ({ type: POST_RESET_PASSWORD_FAILURE, payload: error })